<template>
  <div>
    <div class="sayfahead">
      <h1>{{Sayfa.Adi}}</h1>
      <el-button-group v-if="tableDisplay" class="float-right">

        <el-button type="success" size="small" class="YeniBtn" @click="Excel"
                   icon="el-icon-download">Excel İndir
        </el-button>

      </el-button-group>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo" text="Lütfen Bekleyiniz."></Yukleniyor>
      <el-row :gutter="24">
        <div class="raporbloksabitle">
          <el-form :rules="FormHata" :model="Form"
                   @submit.prevent.native="Getir"
                   ref="RaporForm">
            <el-col :span="8">
              <el-form-item label="Bina" prop="Bina_id">
                <el-select v-model="Form.Bina_id" filterable clearable>
                  <el-option
                    v-for="item in Binalar"
                    :key="item.id"
                    :label="item.Adi"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Avukat" prop="Avukat_id">
                <el-select v-model="Form.Avukat_id" filterable clearable>
                  <el-option
                    v-for="item in Avukatlar"
                    :key="item.id"
                    :label="item.Unvan"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4" :offset="6">
              <el-button type="primary" class="btn-block mt-3" size="medium" @click="Getir()"
                         icon="el-icon-check">Rapor Oluştur
              </el-button>
            </el-col>
          </el-form>
        </div>
      </el-row>
      <el-row :gutter="24">

        <el-col :span="24">

          <el-alert
            v-if="!tableDisplay"
            title="Filtreleme Yapınız"
            type="info"
            :closable="false"
            description="Verilere erişebilemek için lütfen filtreleme yapınız"
          >
          </el-alert>
          <el-table
            v-if="tableDisplay"
            class="table-xs "
            :data="tableData"
            style="width: 100%"
            width="100%"
            show-summary
            :height="Height"
            :summary-method="TableFooter"
          >
            <el-table-column
              label="Kişi Bilgi"
              prop="KisiBilgi">
            </el-table-column>
            <el-table-column
              label="Bina Adı"
              prop="Bina"
              width="300">
            </el-table-column>
            <el-table-column
              label="Avukat"
              prop="Avukat"
              width="200">
            </el-table-column>
            <el-table-column
              label="Dosya No"
              prop="dNo"
              width="100">
            </el-table-column>
            <el-table-column
              label="İcra Tarihi"
              prop="iTarih"
              width="100">
            </el-table-column>

            <el-table-column
              label="Anapara"
              prop="Tutar"
              width="120"
              align="right">
            </el-table-column>
            <el-table-column
              label="Zam"
              prop="ZamTutar"
              width="120"
              align="right">
            </el-table-column>
            <el-table-column
              label="Ödenecek"
              prop="Toplam"
              width="120"
              align="right">
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import XLSX from 'xlsx';
  import Yukleniyor from "../../../components/Doc/Yukleniyor";

  const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({
    name: XLSX.utils.encode_col(i),
    key: i
  }));
  export default {
    components: {Yukleniyor},
    data() {
      return {
        Height: 0,
        FiltreCollapse: '1',
        lo: false,
        Yetki: false,
        Kaydet: false,
        tableDisplay: false,
        Sayfa: {
          Adi: 'İcradaki Dosya Dökümü',
          ButtonAdi: 'Uygula',
          FiltreAdi: 'Filtreleme',
        },
        Form: {
          Avukat_id: null,
          Bina_id: null
        },
        FormHata: {},
        Binalar: null,
        Avukatlar: null,
        MeskenListe: null,
        ExcelData: null,
        AltToplam: {
          Tutar: 0,
          ZamTutar: 0,
          Toplam: 0,
        },
        tableData: null,
        SecilenBina: null
      }
    },
    methods: {
      TableFooter() {
        const sums = [];

        sums[5] = this.AltToplam.Tutar;
        sums[6] = this.AltToplam.ZamTutar;
        sums[7] = this.AltToplam.Toplam;

        return sums;
      },
      Yazdir() {
      },
      Excel(evt) {

        const ws = XLSX.utils.json_to_sheet(this.ExcelData);
        const wb = XLSX.utils.book_new();
        ws['!cols'] = [
          {wch: 50},
          {wch: 20},
          {wch: 10},
          {wch: 10},
          {wch: 20},
          {wch: 20},
          {wch: 20}
        ];
        wb.Props = {
          Title: this.Sayfa.Adi,
          Author: "Aidatim APP",
          Manager: "Aidatim APP",
          Company: "Aidatim",
          Category: "Finans",
          Keywords: "Aidatim",
          Comments: this.Sayfa.Adi,
        };
        XLSX.utils.book_append_sheet(wb, ws, this.SecilenBina);
        XLSX.writeFile(wb, this.Sayfa.Adi + ".xlsx");
      },
      Getir() {
        this.$refs['RaporForm'].validate((valid) => {
          if (valid) {
            this.lo = true;
            this.$store.dispatch("Post", {...this.Form, path: 'raporlama/icra/dosya'})
              .then(response => {

                this.lo = false;
                if (response.Durum == "OK") {
                  this.tableData = response.tableData;
                  this.AltToplam = response.AltToplam;
                  this.ExcelData = response.ExcelData;
                  //this.RaporAdi = response.RaporAdi;
                  if (this.tableData) this.tableDisplay = true;
                  this.Height = window.innerHeight - 220
                } else {
                  this.$message.error(response.Mesaj);
                  this.hata = response.Hata;
                }
              })
          }
        })

      },
      SayfaYukle() {
        this.lo = true;
        this.$store.dispatch("Get", {path: 'muhasebe/list/bina'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Binalar = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
        this.$store.dispatch("Get", {path: 'muhasebe/cari/a/'})
          .then(response => {
            this.lo = false;
            if (response.Durum === 'OK') {
              this.Avukatlar = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      }
    },
    created() {
      this.SayfaYukle();
      if (this.$store.getters.BinaBilgi) {
        this.Form.Bina_id = this.$store.getters.BinaBilgi.id;
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Raporlama/icra/dosya.vue